// extracted by mini-css-extract-plugin
export default {"sidebar":"LessonDemo__sidebar___y149q","courseTitle":"LessonDemo__courseTitle___qoSch"};